<template>
    <div class="block" v-loading="loading">
        <div class="variable">
            <div class="variable-list" v-for="(item, index) in variableList" :key="index">
                <div class="list">
                    <div class="list-title">{{ item.break }}</div>
                    <div class="list-input" v-if="item.field != 'wechat_url' && item.field != 'alipay_url'">
                        <el-input v-model="item.value" clearable :placeholder="'请输入' + item.break"></el-input>
                    </div>

                    <div class="list-input" v-if="item.field == 'wechat_url'">
                        <el-input  v-model="item.value" clearable :placeholder="'请输入' + item.break"
                            @focus="inputMet(0, item.value)"></el-input>
                    </div>

                    <div class="list-input" v-if="item.field == 'alipay_url'">
                        <el-input  v-model="item.value" clearable :placeholder="'请输入' + item.break"
                            @focus="inputMet(1, item.value)"></el-input>
                    </div>
                </div>
            </div>
        </div>
        <div class="submit">
            <div class="submit-button" @click="submitMet">修改提交</div>
        </div>


        <div class="information">
            <el-dialog :visible.sync="informationDialogVisible" @close="informationCancel">
                <span slot="footer" class="dialog-footer">
                    <div class="information-title">
                        <div class="title">{{ informationShow == 0 ? '微信收款二维码' : '支付宝收二维码' }}</div>
                        <img @click="informationCancel" class="img" src="../../assets/common/close.png" alt="" />
                    </div>

                    <div class="information-block">
                        <div class="block-select">
                            <div class="select-title">{{ informationShow == 0 ? '微信收款二维码' : '支付宝收二维码' }}</div>
                            <div class="select">
                                <el-upload class="display-upload"
                                    :style="{ 'color': wechatImage == '' ? '' : '#606266' }"
                                    action="https://laravel-api-manager.xmw1688.com/common/upload"
                                    :on-success="wechatFile" :show-file-list="false" ref="upload">
                                    {{ wechatImage == '' ? informationShow == 0 ? '请输入微信收款二维码' : '请输入支付宝收二维码' : wechatImage }}
                                </el-upload>
                            </div>
                        </div>
                    </div>
                    <div class="information-button">
                        <div class="button-confirm" @click="informationConfirm">确 定</div>
                    </div>
                </span>
            </el-dialog>
        </div>

    </div>
</template>

<script>
import { getSysteminfo, postSysteminfo } from '../../api/partenr'

export default {
    data() {
        return {
            variableList: [],
            // 监听用户刷新
            loading: false,
            // 控制当前页面功能性按钮开关
            variableFunShow: false,
            //----
            wechatImage: '',
            informationDialogVisible: false,
            informationShow: -1
        }
    },
    created() {
        this.loading = true
        this.getSysteminfoMet()

        setTimeout(() => {
            this.variableFunShow = this.$store.state.pageFunctionShow
        }, 1000);

    },
    methods: {
        getSysteminfoMet() {
            let params = {
                model: ''
            }

            getSysteminfo(params).then(res => {
                if (res.resultStatus == true) {
                    this.variableList = res.resultData
                    this.loading = false
                }
            })
        },
        submitMet() {
            if (this.variableFunShow == false) {
                this.$message.error('暂无权限！')
                return
            }

            let params = {
                allSet: this.variableList
            }

            postSysteminfo(params).then(res => {
                if (res.resultStatus == true) {
                    this.loading = true

                    this.$message({
                        message: '修改成功',
                        type: 'success',
                    })
                    this.getSysteminfoMet()
                }
            })
        },

        inputMet(index, obj) {
            this.wechatImage = obj == null ? '': obj
            this.informationShow = index
            this.informationDialogVisible = true
        },

        informationConfirm() {
            this.variableList.forEach((item, index) => {
                if (this.informationShow == 0) {
                    if (item.field == 'wechat_url') {
                        item.value = this.wechatImage
                    }
                } else {
                    if (item.field == 'alipay_url') {
                        item.value = this.wechatImage
                    }
                }
            })

            this.informationDialogVisible = false
        },
        informationCancel() {

            this.informationDialogVisible = false
        },

        // element 上传
        wechatFile(file, fileList) {
            this.$refs.upload.clearFiles()
            this.wechatImage = file.resultData
        },


    }
}
</script>

<style lang="less" scoped>
.block {
    padding-bottom: 20px;
    box-sizing: border-box;
    background: #fff;

    .variable {
        width: 100%;
        min-height: 500px;
        display: flex;
        flex-wrap: wrap;
        padding: 40px;
        box-sizing: border-box;

        .variable-list {
            width: calc((100% / 3));
            height: 40px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;


            .list {
                display: flex;
                align-items: center;
                width: 100%;

                .list-title {
                    font-size: 14px;
                    font-family: PingFangSC-Regular, PingFang SC;
                    font-weight: 400;
                    color: #222222;
                    width: 240px;
                }

                .list-input {
                    width: 45%;
                    height: 44px;

                    /deep/ .el-input.is-disabled .el-input__inner {
                        background-color: #fff;
                        cursor: pointer;
                    }

                    /deep/ .el-input__inner {
                        width: 100%;
                        height: 44px;
                        border-radius: 4px;
                    }

                    .display-upload {
                        width: 100%;
                        height: 44px;
                        border: 0.5px solid #E4E7ED;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        padding: 0 14px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #C0C4CC;
                        box-sizing: border-box;
                    }

                    /deep/ .el-upload {
                        display: inline-block;
                        text-align: left;
                        cursor: pointer;
                        outline: 0;
                        width: 100%;
                    }
                }
            }
        }
    }

    .submit {
        display: flex;
        margin-left: 40px;

        .submit-button {
            background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
            width: 150px;
            height: 40px;
            border: 1px solid;
            display: flex;
            justify-content: center;
            align-items: center;

            font-size: 14px;
            color: #fff;
            font-family: PingFangSC-Regular, PingFang SC;
            cursor: pointer;
            font-weight: 400;

            border-radius: 5px;
        }
    }

    .information {
        /deep/ .el-dialog {
            width: 605px;
        }

        /deep/ .el-dialog__footer {
            padding: 0;
            box-sizing: border-box;
        }

        .information-title {
            height: 56px;
            width: 100%;
            border-bottom: 1px solid #E8E8E8;
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 0 16px;
            box-sizing: border-box;

            .title {
                font-size: 16px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .img {
                width: 11px;
                height: 10px;
                cursor: pointer;
            }
        }

        .information-div {
            .div {
                padding: 20px 24px 6px;
                box-sizing: border-box;
                display: flex;
                flex-wrap: wrap;
                justify-content: space-between;

                border-bottom: 1px solid #E8E8E8;

                .div-list,
                .div-list1 {
                    width: calc(100% / 3 - 50px);
                    text-align: left;
                    margin-bottom: 14px;

                    .list-title {
                        font-size: 12px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #999999;
                        line-height: 17px;
                    }

                    .list-value {
                        font-size: 14px;
                        font-family: PingFangSC, PingFang SC;
                        font-weight: 400;
                        color: #222222;
                        line-height: 20px;
                        margin-top: 4px;
                    }

                    .list-img {
                        display: flex;
                        margin-top: 4px;

                        .img1 {
                            width: 150px;
                            height: 149px;
                            background: #F0F0F0;
                            display: flex;
                            justify-content: center;
                            align-items: center;

                            img {
                                width: 150px;
                                height: 115px;
                                object-fit: cover;
                            }
                        }
                    }
                }

                .div-list1 {
                    width: 100%;
                }
            }
        }

        .information-block {
            padding: 21px 23px;
            box-sizing: border-box;
            text-align: left;

            .block-title {
                font-size: 14px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 600;
                color: #222222;
            }

            .block-select {
                margin-top: 12px;

                .select-title {
                    font-size: 12px;
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 600;
                    color: #505050;
                }

                .select {
                    margin-top: 5px;


                    .display-upload {
                        width: 100%;
                        height: 44px;
                        border: 0.5px solid #E4E7ED;
                        border-radius: 4px;
                        display: flex;
                        align-items: center;
                        padding: 0 14px;
                        font-size: 14px;
                        font-weight: 400;
                        color: #C0C4CC;
                        box-sizing: border-box;
                    }

                    /deep/ .el-upload {
                        display: inline-block;
                        text-align: left;
                        cursor: pointer;
                        outline: 0;
                        width: 100%;
                    }
                }
            }

            .block-text {
                font-size: 12px;
                font-family: PingFangSC, PingFang SC;
                font-weight: 400;
                color: #999999;
                margin-top: 14px;
            }

            .block-textarea {
                height: 206px;
                background: #FFFFFF;
                border-radius: 5px;
                border: 1px solid #D9D9D9;
                margin-top: 5px;
                padding: 0 12px;
                box-sizing: border-box;

                /deep/ .el-textarea__inner:hover {
                    border: 0;
                }

                /deep/ .el-textarea__inner {
                    border: 0;
                    resize: none;
                    height: 100px;
                }

                .textarea-display {
                    .display-upload {
                        display: flex;

                        /deep/ .el-upload--picture-card {
                            width: 100%;
                            height: 100px;
                            display: flex;
                            align-items: center;
                            border: 1px solid rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-upload--picture-card:hover {
                            border-color: rgba(255, 255, 255, 0);
                        }

                        /deep/ .el-upload-list--picture-card .el-upload-list__item {
                            width: 84px;
                            height: 84px;
                            margin: 0;
                        }

                        .display-upload-list {
                            width: 84px;
                            height: 84px;
                            margin-right: 24px;
                            position: relative;
                            border: 1px solid rgba(255, 255, 255, 0);

                            .display-upload-list-img {
                                width: 84px;
                                height: 84px;
                            }
                        }

                        .display-upload-list:last-child {
                            margin-right: 0;
                        }

                        .display-upload-detele {
                            position: absolute;
                            top: -10px;
                            right: -10px;
                            width: 20px;
                            height: 20px;
                        }
                    }
                }
            }
        }

        .information-button {
            width: 100%;
            height: 52px;
            display: flex;
            align-items: center;
            justify-content: flex-end;
            padding: 0 16px;
            box-sizing: border-box;
            border-top: 1px solid #d9d9d9;
            margin-top: 25px;

            .button-reset,
            .button-confirm {
                width: 65px;
                height: 32px;
                background: #ffffff;
                border-radius: 10px;
                border: 1px solid #e9edf4;
                font-size: 14px;
                font-family: PingFangSC-Regular, PingFang SC;
                font-weight: 400;
                color: #555555;
                text-align: center;
                line-height: 32px;
                cursor: pointer;
            }

            .button-confirm {
                background: linear-gradient(135deg, #36c53d 0%, #3fd747 100%);
                color: #ffffff;
                margin-left: 8px;
            }
        }

    }
}
</style>
